var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRuntbordny01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    "data-name": "Lager 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 326.08 311.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3{fill:#fff;}.cls-2{clip-path:url(#clip-path);}.cls-3{stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "-8 319.54 334.08 319.54 334.08 -8 -8 -8 -8 319.54"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "253.04 155.77 252.61 164.59 251.31 173.33 249.16 181.89 246.19 190.21 242.41 198.19 237.87 205.77 232.61 212.86 226.68 219.41 220.14 225.34 213.04 230.6 205.47 235.14 197.48 238.92 189.17 241.89 180.6 244.04 171.86 245.34 163.04 245.77 154.22 245.34 145.48 244.04 136.91 241.89 128.6 238.92 120.61 235.14 113.04 230.6 105.94 225.34 99.4 219.41 93.47 212.86 88.21 205.77 83.67 198.19 79.89 190.21 76.92 181.89 74.77 173.33 73.47 164.59 73.04 155.77 73.47 146.95 74.77 138.21 76.92 129.64 79.89 121.33 83.67 113.34 88.21 105.77 93.47 98.67 99.4 92.13 105.94 86.2 113.04 80.94 120.61 76.4 128.6 72.62 136.91 69.64 145.48 67.5 154.22 66.2 163.04 65.77 171.86 66.2 180.6 67.5 189.17 69.64 197.48 72.62 205.47 76.4 213.04 80.94 220.14 86.2 226.68 92.13 232.61 98.67 237.87 105.77 242.41 113.34 246.19 121.33 249.16 129.64 251.31 138.21 252.61 146.95 253.04 155.77"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "258.08 128.77 318.08 128.77 318.08 182.77 258.08 182.77 258.08 128.77"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "309.08 128.77 318.08 128.77 318.08 182.77 309.08 182.77 309.08 128.77"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "233.94 224.58 263.94 276.54 217.18 303.54 187.18 251.58 233.94 224.58"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "259.44 268.75 263.94 276.54 217.18 303.54 212.68 295.75 259.44 268.75"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "138.9 251.58 108.9 303.54 62.14 276.54 92.14 224.58 138.9 251.58"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "113.4 295.75 108.9 303.54 62.14 276.54 66.64 268.75 113.4 295.75"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "68 182.77 8 182.77 8 128.77 68 128.77 68 182.77"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "17 182.77 8 182.77 8 128.77 17 128.77 17 182.77"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "92.14 86.96 62.14 35 108.9 8 138.9 59.96 92.14 86.96"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "66.64 42.79 62.14 35 108.9 8 113.4 15.79 66.64 42.79"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "187.18 59.96 217.18 8 263.94 35 233.94 86.96 187.18 59.96"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "212.68 15.79 217.18 8 263.94 35 259.44 42.79 212.68 15.79"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRuntbordny01);
export default __webpack_public_path__ + "static/media/runt bord ny-01.fefda21dafb7814015a26c7f5a5502f1.svg";
export { ForwardRef as ReactComponent };